import { orderBy, uniqBy, first } from 'lodash';

export function getInitials(name = '') {
  return name
    .split(' ')
    .map((n) => n[0].toUpperCase())
    .join('')
    .slice(0, 2);
}

export function getSchoolOptions(schools) {
  if (!schools) return [];
  return schools.map((s) => ({ value: s.idCSchool, label: s.name }));
}

export function getCatalogingSegmentOptions(info) {
  return info.catalogingSegmentName
    ? [{ label: info.catalogingSegmentName, value: info.idCatalogingSegment }]
    : [];
}

export function getCatalogingLevelNameOptions(info) {
  return info.catalogingLevelName
    ? [{ label: info.catalogingLevelName, value: info.idCatalogingLevel }]
    : [];
}

// use group as a fallback for creating options and avoid see empty values in select (see SA-268)
export function getLevelOptions(levels, group) {
  if (!levels) return [];
  const primaryLevels = levels.map((l) => ({ value: l.id, label: l.name }));
  const fallbackLevels = [{ value: group.idCatalogingSegment, label: group.catalogingSegmentName }];
  const missingValueInArray =
    group &&
    group.idCatalogingSegment &&
    !primaryLevels.every((l) => l.value === group.idCatalogingSegment);
  return missingValueInArray ? fallbackLevels : primaryLevels;
}

// use group as a fallback for creating options and avoid see empty values in select (see SA-268)
export function getClassOptions(classes, group) {
  if (!classes) return [];
  const primaryClasses = Object.keys(classes).map((key) => ({
    value: classes[key].id,
    label: classes[key].name,
  }));
  const fallbackClasses = [{ value: group.idCatalogingLevel, label: group.catalogingLevelName }];
  const missingValueInArray =
    group &&
    group.idCatalogingLevel &&
    !primaryClasses.some((l) => l.value === group.idCatalogingLevel);
  return missingValueInArray ? fallbackClasses : primaryClasses;
}

export function getPeriodOptions(periods) {
  if (!periods) return [];
  return periods.map((p) => ({ value: p.name, label: p.name }));
}

export const getGroups = (groups = []) => {
  if (!groups.length) return [];
  const groupsList = uniqBy(
    groups.map((e) => ({
      value: e.idCourse,
      label: `${e.courseName} - ${e.levelName}`,
    })),
  );

  return groupsList;
};
